export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
// export const API_BASE = 'https://fordgb.directaffinitycx.net/api/v1'
export const API_BASE = 'https://oem-demo.directaffinitycx.net/api/v1'
export const API_BASE2 = 'https://oem-demo.directaffinitycx.net/api/v1'
// export const API_BASE = 'http://localhost:3012/api'
export const AUTH_API_KEY='f84fa777-35e5-4ceb-b18a-beae2f4e1df1'